import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';

const InteriorDesignerDashboard = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  // Redirect to settings page as the main dashboard
  React.useEffect(() => {
    navigate('/interior-designer/settings');
  }, [navigate]);

  return null;
};

export default InteriorDesignerDashboard;
